










import { Prop, Component, Vue } from 'vue-property-decorator'

export interface ListItemActionClickEvent<T> {
    item: T
}

@Component
export default class ListItemAction<T> extends Vue {
    @Prop({ type: Object }) readonly item!: T
    @Prop({ type: String, default: null }) readonly icon!: string
    @Prop({ type: String, default: null }) readonly label!: string
}
